export default __webpack_public_path__ + "static/media/MIND-01-01.48372de1.png";